/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 13/11/2023
 */


import { apiSlice } from '../Slices/apiSlice';

export const FrequencyService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllFrequencies: builder.query({
            query: () => "/frequency",
            providesTags: ['freq']
        }),

        getFrequencyById: builder.query({
            query: (id) => `/frequency/${id}`,
            providesTags: ['freq']
        }),

        createFrequency: builder.mutation({
            query: (details) => ({
                url: '/frequency',
                method: 'POST',
                body: details
            }),
            invalidatesTags: ['freq']
        }),

        updateFrequency: builder.mutation({
            query: (details) => ({
                url: `/frequency/${details.freqId}`,
                method: 'PUT',
                body: details
            }),
            invalidatesTags: ['freq']
        }),

        deleteFrequency: builder.mutation({
            query: (id) => ({
                url: `/frequency/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['freq']
        }),

    })
});

export const {
    useGetAllFrequenciesQuery,
    useGetFrequencyByIdQuery,
    useCreateFrequencyMutation,
    useUpdateFrequencyMutation,
    useDeleteFrequencyMutation,
} = FrequencyService;